import { FunctionComponent, useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { deleteCookie, getCookie } from "../../utils/cookies";
import { AuthService } from "../../services/auth";
import { AuthContext } from "../../context/AuthContext";
import { UserContext } from "../../context/UserContext";
import Loading from "../common/Loading";

interface PrivateRoutesProps {}

const PrivateRoutes: FunctionComponent<PrivateRoutesProps> = () => {
  const { isAuth, setIsAuth, saveAuthCookies } = useContext(AuthContext);
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const accessTokenCookie = getCookie(document.cookie, "accessToken");
      const refreshTokenCookie = getCookie(document.cookie, "refreshToken");

      if (!accessTokenCookie && refreshTokenCookie) {
        const { token, email } = JSON.parse(refreshTokenCookie);

        try {
          const newToken = await AuthService.refreshToken(token, email);
          saveAuthCookies({ ...newToken.tokenData, email });
        } catch (e) {
          deleteCookie("refreshToken");
          setIsAuth(false);
          setLoading(false);
          return;
        }
      } else if (!accessTokenCookie && !refreshTokenCookie) {
        setLoading(false);
        return;
      }

      try {
        const { email, phoneNumber, name, lastName, companyName } =
          await AuthService.getUserFromToken();
        setUser({ ...user, email, phoneNumber, name, lastName, companyName });
        setLoading(false);
      } catch (error) {
        deleteCookie("accessToken");
        setIsAuth(false);
        setLoading(false);
        return;
      }
    })();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
